import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { SectionHeading } from "./Services";
import { ArrowUpRight } from "lucide-react";

export default function Companies() {
  const { t } = useLang();
  const c = t.companies;
  const ref = useReveal();

  return (
    <section id="empresas" className="bg-[#0d2140] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} dark />

        <div ref={ref} className="reveal mt-14 grid md:grid-cols-3 gap-8">
          {c.items.map((item, i) => (
            <div
              key={i}
              className="card-hover group bg-[#12294c] rounded-2xl border border-white/10 p-8 hover:border-[#f5871f]/50"
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-16 h-16 rounded-xl bg-white/10 border border-white/15 font-display font-700 text-white text-lg tracking-wide">
                  {item.initials}
                </span>
                <ArrowUpRight className="w-6 h-6 text-white/30 group-hover:text-[#f5871f] transition-colors" />
              </div>
              <h3 className="mt-6 font-display font-700 text-2xl uppercase text-[#f5871f]">{item.name}</h3>
              <p className="mt-3 text-white/65 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
